import React from "react";
import '../../sass/components/_components.footerBanner.scss';

const FooterBannerTwo = () => {
    return (
        <div className="cp-footerBanner" style={{ backgroundColor: `#7C4FFF` }}>
            <div className="cp-footerBanner__inner" style={{ maxWidth: `1300px` }}>
                <h2 className="l--maxWidth752">When finance is a team sport, Everyone’s a champion</h2>
                <div className="cp-footerBanner__buttons">
                    <a href="/resources/on-demand-webinars/planful-live-demo/" className="l-button l-buttonDark">Watch demo</a>
                    <a href="/contact-us/" className="l-button">Contact Us</a>
                </div>
            </div>
        </div>
    )
}

export default FooterBannerTwo;